module.exports = __webpack_public_path__ + "img/app-landing.3b2105ae.jpg";